

import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material';
import { SadevLoginComponent } from './login/login.component';
// import { SharedMethods } from '../util/sharedMethods-service';


@Injectable()
export class AuthGuard implements CanActivate {


  constructor(private _authService: AuthService, private dialog: MatDialog, ) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    /* if (this._authService.isAuthenticated()) {

        return true;

    } */

    // on sauvegarde les permissions qu'il faut pour la page
    this._authService.permissionsToRedirect = next.data.permissions;


    // gestion avec les rôles on verifie si l'utilisateur est déjà connecter
    if (this._authService.token !== undefined && this._authService.token !== null) {

         /* if ( state.url === '/pages/dashboard') {

            this.router.navigate(['/pages/test']);
            return false;

         } else {

            return true;

         } */

         return true;

    }

    //  l'utilisateur n'est pas déjà connecter
    // if (state.url !== '/pages/login')
    this._authService.redirect = state.url;
    console.log(this._authService.redirect);

    // navigate to login page
    // this.router.navigate(['/pages/login']);

    this.openLoginDialog();

    /* dialogRef.afterClosed().subscribe(product => {
      if(product){
        this.router.navigate(['/products', product.id, product.name]);
      }
    }); */

    // you can save redirect url so after authing we can move them back to the page they requested
    return false;

  }

  openLoginDialog(affiliate?) {

    const dialogRef = this.dialog.open(SadevLoginComponent, {
      // data: product,
      panelClass: 'product-dialog',
      // height: '400px',
      width: '350px',
    });

    dialogRef.componentInstance.affiliate = affiliate;

  }


}
